<template>
    <div>
        <div class="display-f just-b align-i-c">
            <div style="width: 90%;" class="display-f align-i-c">
                <!-- <el-date-picker @change="dateChange" v-model="timeRange" type="daterange" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions">
                </el-date-picker> -->
                <el-date-picker @change="dateChange" v-model="timeRange" type="date" placeholder="选择日期" format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" :picker-options="pickerOptions" @focus="isShow($event)">
                </el-date-picker>
                <el-button type="primary" class="ml16" icon="el-icon-search" @click="getCheckAccount">查询</el-button>
            </div>
            <el-button type="primary" @click="oneKeyCheck">一键对账</el-button>
        </div>
        <div v-if="checkAccount.billCensus && checkAccount.billCensus.wrongNum > 0"
            :class="checkAccount.billCensus.waitHandleNum == 0 ? 'backE8F' : 'back0E1'"
            class="mt16 w100_ display-f align-i-c jc_c size12 color3F4" style="height: 30px;">
            共有异常结算{{ checkAccount.billCensus.wrongNum }}笔，<span class="mr12">{{ checkAccount.billCensus.waitHandleNum > 0 ?
                checkAccount.billCensus.waitHandleNum + '笔待处理' : '已全部处理' }}</span>
            <el-link type="primary" class="size12" @click="getStmtDetail(0)">详情</el-link>
        </div>
        <div class="mt16 " v-loading="loading">
            <custom-table class="tableC" :column="checkAccountTable" :tableData="checkAccount.items" :showPages="false">
                <template slot="clrType" slot-scope="{row}">
                    <div v-if="clrTypeList.length > 0 && row.provinceFlag != '1'">
                        {{ computedName(clrTypeList, row.clrType) }}
                    </div>
                    <div v-if="(row.clrType == '11' && row.provinceFlag == '1')">
                        省本级门诊清算
                    </div>
                </template>
                <template slot="insutype" slot-scope="{row}">
                    <div v-if="insuTypeList.length > 0">
                        {{ computedName(insuTypeList, row.insutype) }}
                    </div>
                </template>
                <template slot="clrOptins" slot-scope="{row}">
                    <div v-if="clrOptinsList.length > 0">
                        {{ computedName(clrOptinsList, row.clrOptins) }}
                    </div>
                </template>
                <template slot="checkFlag" slot-scope="{row}">
                    <div style="display: flex;">
                        <div :class="row.checkFlag == 2 ? 'parTag' : row.checkFlag == 1 ? 'infoTag' : 'errTag'">{{
                            row.checkFlag == 2 ? '未对账' : row.checkFlag == 1 ? '对账成功' : row.checkFlag == 3 ? '部分对账' : '对账失败'
                        }}</div>
                    </div>
                </template>
                <template slot="handle" slot-scope="{row}">
                    <el-button type="text" @click="getStmtDetail(1, row)">明细</el-button>
                    <!-- <el-button type="text" v-if="row.checkFlag != 1" @click="submitStmt(row)">对账</el-button> -->
                    <el-button type="text" @click="submitStmt(row)">对账</el-button>
                </template>
            </custom-table>
            <div class="mt16 display-f just-b align-i-c" v-if="checkAccount.billCensus">
                <div class="color3F4 size14 ">共<span class="color1F2 font600">{{
                    checkAccount.billCensus.settleCount }}</span>条数据，医疗费用总额<span class="color1F2 font600">{{
        checkAccount.billCensus.medfeeSumamt }}</span>元，基金支付总额<span class="color1F2 font600">{{
        checkAccount.billCensus.fundPaySumamt }}</span>元，钱包支付总额<span class="color1F2 font600">{{
        checkAccount.billCensus.wltpayAmt }}</span>元，个人账户总额<span class="color1F2 font600">{{
        checkAccount.billCensus.acctPay }}</span>元</div>
            </div>
        </div>
        <custom-dialog :visible.sync="detailDialog" title="结算明细" :showFooter="false" dialogWidth="980px"
            @close="closeDialog">
            <custom-table class="tableC" :column="detailCheckTable" :tableData="checkDetailAccount" :showPages="false"
                max-height="286">
                <template slot="clrType" slot-scope="{row}">
                    <div v-if="clrTypeList.length > 0 && row.provinceFlag != '1'">
                        {{ computedName(clrTypeList, row.clrType) }}
                    </div>
                    <div v-if="(row.clrType == '11' && row.provinceFlag == '1')">
                        省本级门诊清算
                    </div>
                </template>
                <template slot="settleType" slot-scope="{row}">
                    <span>{{ row.settleType == 0 ? '收费' : '退费' }}</span>
                </template>
                <template slot="checkResultStatus" slot-scope="{row}">
                    <el-tooltip v-if="row.checkResultStatus == 0 && row.prmmsg" class="item" effect="light"
                        :content="row.prmmsg" placement="bottom">
                        <div class="colorF54">不平</div>
                    </el-tooltip>
                    <div style="display: flex;" v-else>
                        <div :class="row.checkResultStatus == 0 ? 'colorF54' : 'color189'">{{
                            row.checkResultStatus == 0 ? '不平' : row.checkResultStatus == 1 ? '平' :
                            row.checkResultStatus == 2 ? '已冲正' : row.checkResultStatus == 3 ? '未对账' : row.checkResultStatus
                                == 4 ? '已清算' : '待冲正' }}</div>
                    </div>
                </template>
                <template slot="handle" slot-scope="{row}">
                    <div type="primary" :class="detailDialogType == 0 ? 'color189' : 'color1F2'"
                        v-if="row.checkResultStatus == 1 || row.checkResultStatus == 2">{{ detailDialogType == 0 ? '结算记录' :
                            '正常结算' }}
                    </div>
                    <div v-if="row.checkResultStatus == 0" class="color1F2">异常结算</div>
                    <!-- <div type="primary" class="color189 pointer" v-if="row.checkResultStatus == 3">对账</div> -->
                </template>
            </custom-table>
            <div class="mt16" style="text-align: right;">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pages.pageNum" :page-sizes="[10, 20, 30, 40]" :page-size="pages.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="checkDetailTotal">
                </el-pagination>
            </div>
        </custom-dialog>
        <!-- 对账中提示 -->
        <custom-dialog :visible.sync="hintDialog" title="提示" :showFooter="false" dialogWidth="398px">
            <div>正在对账中，请耐心等待</div>

        </custom-dialog>
    </div>
</template>

<script>
import { checkAccountListApi, checkDetailAccountListApi, getCheckAccountTotalApi, checkDetailAccountAllListApi, updateCheckListApi, getCheckAccountDetailApi, getCheckDateApi, getDetailPayApi, getDetailPsnApi, diffAccountCheckingDetailApi, updateCheckDiffListApi } from '@/api/medInsuranceAccount.js';
import CustomTable from '@/components/customTable/customTable.vue';
import CustomDialog from '@/components/customDialog/index.vue';
import { MedicalInsurance } from '../medicalInsurance.js';
import { CommonDTO } from '@/DTO/index.js';
export default {
    components: {
        CustomTable,
        CustomDialog
    },
    data() {
        return {
            loading: false,
            formData: {
                deptId: this.$session.get('deptId'), // 当前医馆id
            },
            timeRange: null,
            pages: {
                currentPage: 1,
                pageSize: 10
            },
            checkAccountTable: [
                { prop: 'clrType', label: '清算类别', slotName: 'clrType', align: 'left' },
                { prop: 'insutype', label: '险种类型', slotName: 'insutype', align: 'left' },
                { prop: 'clrOptins', label: '经办机构', slotName: 'clrOptins', align: 'left' },
                { prop: 'medfeeSumamt', label: '医疗费用总额', align: 'left' },
                { prop: 'fundPaySumamt', label: '基金支付总额', align: 'left' },
                { prop: 'acctPay', label: '个人账户总额', align: 'left' },
                { prop: 'wltpayAmt', label: '钱包支付总额', align: 'left' },
                { prop: 'settleCount', label: '结算笔数', align: 'left' },
                { prop: '', label: '对账结果', slotName: 'checkFlag', align: 'left' },
                { prop: '', label: '操作', slotName: 'handle', align: 'left' },
            ],
            checkAccount: {},//对账列表等信息
            detailDialog: false,
            detailDialogType: 0,
            detailCheckTable: [
                { prop: 'clrType', label: '清算类别', slotName: 'clrType', align: 'left' },
                { prop: 'settleType', label: '类型', slotName: 'settleType', align: 'left' },
                { prop: 'psnName', label: '人员姓名', align: 'left' },
                { prop: 'medfeeSumamt', label: '医疗费用总额', align: 'left' },
                { prop: 'fundPaySumamt', label: '基金支付总额', align: 'left' },
                { prop: 'acctPay', label: '个人账户支出', align: 'left' },
                { prop: 'wltpayAmt', label: '钱包支付支出', align: 'left' },
                { prop: 'setlTime', label: '结算时间', align: 'left', width: '200' },
                { prop: '', label: '结果', slotName: 'checkResultStatus', align: 'left' },
                { prop: '', label: '操作/状态', slotName: 'handle', align: 'left' },
            ],
            checkDetailAccount: [],//对账明细
            checkDetailTotal: 0,//对账明细总数
            //险种类型
            insuTypeList: [],
            clrTypeList: [],
            clrOptinsList: [],
            checkRow: {},//对账
            detailRow: {},//明细
            checkDateList: [],//是否对账日期
            deptId: this.$session.get('deptId'), // 当前医馆id
            diffDetailList: [],//对明细返回的diff数组
            diffCenter: [],//中心多的数据
            upObj: null,//差异上传的对象
            //一键对账
            oneKey: false,//是否可以一键对账
            oneKeyIndex: 0,//一键对账index
            //对账中提示
            hintDialog: false,//对账中提示弹框
            sysTime: null,//系统时间
        }
    },
    created() {
        this.init()
    },
    computed: {
        pickerOptions() {
            let that = this
            return {
                cellClassName(Date) {
                    if (that.checkDateList.some(val => val.data == that.$moment(Date).format("yyyy-MM-DD") && val.checkFlag == 1)) {
                        return 'color30C'
                    } else {
                        return 'colorF54'
                    }
                },
                disabledDate(time) {
                    return time.getTime() > that.sysTime;
                }
            }
        },
        computedName() {
            return function (list, code) {
                return list.filter(val => val.code == code).length > 0 ? list.filter(val => val.code == code)[0].name : code
            }
        }
    },
    methods: {
        async init() {
            let time = await this.getSysTime()
            this.sysTime = this.$moment(time).valueOf()
            this.timeRange = CommonDTO.timeFormat(time)
            this.$set(this.formData, 'startTime', CommonDTO.startOfDay(time))
            this.$set(this.formData, 'endTime', CommonDTO.endOfDay(time))
            this.getTypeList()
            if (this.formData.startTime && this.formData.endTime) this.getCheckAccount()
            this.getCheckDate(this.timeRange)
        },
        async getSysTime() {
            let res = await CommonDTO.getSystemTimeDTO()
            return new Date(res)
        },
        async getCheckAccount() {
            if (!this.formData.startTime || !this.formData.endTime) {
                this.$message.error('请选择时间')
                return false;
            }
            this.loading = true
            let checkRes = await checkAccountListApi(this.formData)
            if (checkRes.code == 200) {
                this.checkAccount = checkRes.data
            }
            this.loading = false
        },
        dateChange(val) {
            if (!val) {
                console.log(333);
                this.$message.error('请选择时间')
                return false;
            }
            this.formData.startTime = this.startOfDay(val);
            this.formData.endTime = this.endOfDay(val);
            this.getCheckDate(val)
            this.getCheckAccount()
        },
        // 获取焦点 展示日期
        async isShow(e) {
            await this.$nextTick()
            document.querySelectorAll("[aria-label='下个月'],[aria-label='上个月'],[aria-label='后一年'],[aria-label='前一年']")
                .forEach(item => item.onclick = () => {
                    this.getCheckDate()
                })
        },
        startOfDay(start) {
            return _.toString(new Date(this.$moment(start).startOf('day')).getTime())
        },
        endOfDay(end) {
            return _.toString(new Date(this.$moment(end).endOf('day')).getTime())
        },
        startMonth(start) {
            let month = this.$moment(start).startOf('month').format("yyyy-MM-DD")
            let startDay = this.startOfDay(month)
            return startDay
        },
        endMonth(end) {
            let month = this.$moment(end).endOf('month').format("yyyy-MM-DD")
            let endDay = this.endOfDay(month)
            return endDay
        },
        async getCheckDate(val) {
            let obj;
            if (val) {
                obj = {
                    startTime: this.startMonth(val),
                    endTime: this.endMonth(val),
                    deptId: this.deptId
                }
            }
            if (document.querySelectorAll('.el-date-picker__header-label')[0] && !val) {
                let year = document.querySelectorAll('.el-date-picker__header-label')[0].innerHTML.slice(0, 4)
                let month = document.querySelectorAll('.el-date-picker__header-label')[1].innerHTML.slice(0, -1)
                obj = {
                    startTime: this.startMonth(`${year}-${month}`),
                    endTime: this.endMonth(`${year}-${month}`),
                    deptId: this.deptId
                }
            }
            let res = await getCheckDateApi(obj)
            if (res.code == 200) {
                this.checkDateList = res.data
            }
        },
        //获取code列表状态
        async getTypeList() {
            const { insuTypeList, clrTypeList, clrOptinsList } = await MedicalInsurance.getTypeList()
            //险种类型
            this.insuTypeList = insuTypeList
            this.clrTypeList = clrTypeList
            this.clrOptinsList = clrOptinsList
        },
        //分页
        handleSizeChange(val) {
            this.pages.pageSize = val
            this.getStmtDetail(this.detailDialogType, this.detailRow)
        },
        handleCurrentChange(val) {
            this.pages.currentPage = val
            this.getStmtDetail(this.detailDialogType, this.detailRow)
        },
        //关闭弹窗
        closeDialog() {
            this.detailRow = {};
            this.pages.currentPage = 1;
            this.pages.pageSize = 10;
        },
        //获取分页对账明细
        async getStmtDetail(type, row) {
            this.detailDialog = true;
            this.detailDialogType = type;
            let obj = {
                type,
                ...this.formData,
                ...this.pages
            }
            if (row && !_.isEmpty(row)) {
                this.detailRow = row
                obj.clrType = row.clrType;
                obj.insutype = row.insutype;
                obj.clrOptins = row.clrOptins;
                obj.provinceFlag = row.provinceFlag;
            }
            let res = await checkDetailAccountListApi(obj)
            if (res.code == 200) {
                this.checkDetailAccount = res.rows;
                this.checkDetailTotal = res.total;
            }
        },
        //获取所有对账明细
        async getStmtDetailAll(row, upObj) {
            let res = await checkDetailAccountAllListApi(upObj)
            if (res.code == 200) {
                if (row.clrType == '99915' || (row.clrType == '11' && row.provinceFlag == '1')) {
                    this.submitStmtDetail(row, res.data)
                } else {
                    //对省外明细
                    this.diffAccountCheckDetail(row, res.data)
                }
            }
        },
        //对账
        async submitStmt(row) {
            this.loading = true
            this.hintDialog = true
            this.checkRow = row
            let upObj = {
                ...this.formData,
                clrType: row.clrType,
                insutype: row.insutype,
                clrOptins: row.clrOptins,
            }
            //省外对账直接对明细
            // if (row.clrType != '99915' && row.clrType !='51'  ) {
            //     upObj.provinceFlag = row.provinceFlag
            //     this.getStmtDetailAll(row, upObj)
            //     return false;
            // }
            if ( row.clrType=='N11' || (row.clrOptins =='510100' && row.clrType=='11') ||  (row.provinceFlag =='2' && row.clrOptins =='519900' && row.clrType=='11' ) || (row.provinceFlag =='0' && row.clrType=='11' && row.clrOptins=='511300' ) ) {
                upObj.provinceFlag = row.provinceFlag
                this.getStmtDetailAll(row, upObj)
                return false;
            }
            let obj = {
                clr_optins: row.clrOptins,
                insutype: row.insutype,//险种  字符型	6	Y Y
                clr_type: row.clrType,//清算类别    字符型	6	Y Y
                setl_optins: row.clrOptins,//结算经办机构
                stmt_begndate: this.timeRange,//开始时间
                stmt_enddate: this.timeRange,//结束时间
                medfee_sumamt: row.realMedfeeSumamt, //医疗费总额 数值型	16,2		Y
                fund_pay_sumamt: row.realFundPaySumamt, //基金支付总额 数值型	16,2		Y
                acct_pay: row.realAcctPay,//个人账户支付金额 数值型	16,2		Y
                fixmedins_setl_cnt: row.realSettleCount,//定点医药机构结算笔数 数值型	10		Y
                wltpay_amt:row.wltpayAmt
            }
            let res = await getCheckAccountTotalApi(obj)
            if (res.code == 200) {

                if (res.data.stmtinfo.stmt_rslt == 0) {
                    //平
                    this.updateCheckList(upObj)
                    this.loading = false
                    this.hintDialog = false
                } else {
                    //不平，查明细，查了对明细
                    this.getStmtDetailAll(row, upObj)
                }
            } else {
                this.clearInfo()
            }
        },
        //清理信息
        clearInfo() {
            this.oneKey = false
            this.oneKeyIndex = 0
            this.loading = false
            this.hintDialog = false;
            // this.$message.error('对账失败')
        },
        //对异地明细
        async diffAccountCheckDetail(row, list) {
            let obj = {
                clr_optins: row.clrOptins,//结算经办机构
            }
            let lists = list.filter(val => val.checkResultStatus != 5)
            obj.data = lists.map(val => {
                return {
                    psn_no: val.psnNo,//人员编号 字符型	30		Y
                    medfee_sumamt: val.medfeeSumamt,//医疗费总额 数值型	16,2		Y
                    optins_pay_sumamt: Number(this.$bigNumber(val.fundPaySumamt, '+', val.acctPay)),//经办机构支付总额 数值型	16,2		Y 基金支付总额+个人账户支付
                    mdtrt_setl_time: val.setlTime,//就诊结算时间 日期时间型           Y 格式：YYYYMMDDHH24MISS
                    trns_type: val.settleType == '0' ? '1' : '-1',//交易类型 字符型	3	Y Y   标记正反交易(1.正交易	-1.负交易)
                    mdtrt_id: val.mdtrtId,//就诊顺序号 字符型	20	　	Y
                    setl_id: val.setlId//结算流水号 字符型	20	　	Y
                }
            })
            let res = await diffAccountCheckingDetailApi(obj)
            if (res.code == 200) {
                this.updateDiffListDetail(res.data)
            } else {
                setTimeout(() => {
                    this.clearInfo()
                }, 1000)
            }
        },
        //异地对账完成后更新数据
        async updateDiffListDetail(result) {
            let res = await updateCheckDiffListApi(result)
            if (res.code == 200) {
                this.loading = false
                this.hintDialog = false
                if (res.code == 200) {
                    if (this.oneKey) {
                        this.oneKeyIndex += 1
                        this.oneKeyCheck()
                    } else {
                        this.oneKeyIndex = 0
                        this.getCheckAccount()
                    }
                }
            }
        },
        //对明细
        async submitStmtDetail(row, list) {
            let obj = {
                stmt_begndate: this.timeRange,//对账开始日期  日期型 Y   yyyy-MM-dd
                stmt_enddate: this.timeRange,//对账结束日期 日期型 Y yyyy-MM-dd
                medfee_sumamt: row.realMedfeeSumamt,//医疗费总额 数值型	16,2 Y
                fund_pay_sumamt: row.realFundPaySumamt,//基金支付总额 数值型	16,2 Y
                cash_payamt: row.realPsnPartAmt,//现金支付金额 数值型	16,2 Y
                fixmedins_setl_cnt: row.realSettleCount,//定点医药机构结算笔数 数值型	10		Y
                clr_type: row.clrType,//清算类别 字符型	6	Y
                setl_optins: row.clrOptins,//结算经办机构
                insutype: row.insutype,//险种  字符型	6	Y Y
                clr_optins: row.clrOptins,
                // refd_setl_flag: "",//退费结算标志 字符型	3	Y
            }
            let lists = list.filter(val => val.checkResultStatus != 5)
            obj.items = lists.map(val => {
                return {
                    setl_id: val.setlId,
                    mdtrt_id: val.mdtrtId,
                    psn_no: val.psnNo,
                    medfee_sumamt: val.medfeeSumamt,
                    fund_pay_sumamt: val.fundPaySumamt,
                    acct_pay: val.acctPay,
                    refd_setl_flag: val.realSettleType,
                    setl_optins: val.clrOptins,
                    exp_content:{
                      wltpay_amt:val.wltpayAmt
                    }
                }
            })
            let diffRes = await getCheckAccountDetailApi(obj)
            if (diffRes.code == 200) {
                let centerMore = diffRes.data.diff.filter(val => val.stmt_rslt == 101);
                let diffList = diffRes.data.diff.filter(val => val.stmt_rslt != 101)
                this.diffDetailList = diffList.map(val => {
                    return {
                        psnNo: val.psn_no,
                        mdtrtId: val.mdtrt_id,
                        setlId: val.setl_id,
                        msgId: val.msgid,
                        stmtRslt: val.stmt_rslt,
                        refdSetlFlag: val.refd_setl_flag,
                        memo: val.memo,
                        medfeeSumamt: val.medfee_sumamt,
                        fundPaySumamt: val.fund_pay_sumamt,
                        acctPay: val.acct_pay,
                    }
                })
                this.upObj = {
                    ...this.formData,
                    clrType: row.clrType,
                    insutype: row.insutype,
                    clrOptins: row.clrOptins,
                }
                if (!_.isEmpty(centerMore)) {
                    this.getFeeInfo(centerMore, 0,row.clrOptins)
                } else {
                    this.updateCheckList(this.upObj)
                }
            } else {
                this.clearInfo()
            }
        },
        //更新对账明细
        async updateCheckList(obj) {
            let diff = this.diffDetailList.concat(this.diffCenter)
            let diffObj = {
                ...obj,
                diff,
                different: _.isEmpty(diff) ? 0 : 1
            }
            let res = await updateCheckListApi(diffObj)
            this.loading = false
            this.hintDialog = false
            this.diffCenter = [];
            this.diffDetailList = [];
            if (res.code == 200) {
                if (this.oneKey) {
                    this.oneKeyIndex += 1
                    this.oneKeyCheck()
                } else {
                    this.oneKeyIndex = 0
                    this.getCheckAccount()
                }
            }
        },
        //中心多的数据费用明细查询
        getFeeInfo(list, index = 0,clrOptins) {
            if (index >= list.length) {
                this.updateCheckList(this.upObj)
                return;
            }
            let obj = {
                mdtrt_id: list[index].mdtrt_id,//就诊ID
                setl_id: list[index].setl_id,//结算ID
                psn_no: list[index].psn_no,//人员编号
                insuplc_admdvs:clrOptins
            }
            getDetailPayApi(obj).then(res => {
                if (res.code == 200) {
                    let data = res.data.setlinfo || {}
                    this.diffCenter.push({
                        psnNo: data.psn_no,
                        mdtrtId: data.mdtrt_id,
                        setlId: data.setl_id,
                        msgId: list[index].msgid,
                        stmtRslt: list[index].stmt_rslt,
                        refdSetlFlag: list[index].refd_setl_flag,
                        memo: list[index].memo,
                        medfeeSumamt: data.medfee_sumamt,
                        fundPaySumamt: data.fund_pay_sumamt,
                        acctPay: data.acct_pay,
                        //以下是补充字段
                        psnName: data.psn_name,//人员姓名
                        psnCertType: data.psn_cert_type,//人员证件类型
                        certno: data.certno,//证件号码
                        gend: data.gend,//性别
                        naty: data.naty,//民族
                        brdy: data.brdy,//出生日期
                        age: data.age,//年龄
                        insutype: data.insutype,//险种类型
                        psnType: data.psn_type,//人员类别
                        cvlservFlag: data.cvlserv_flag,//公务员标志
                        mdtrtCertType: data.mdtrt_cert_type,//就诊凭证类型
                        medType: data.med_type,//医疗类别
                        fulamtOwnpayAmt: data.fulamt_ownpay_amt,//全自费金额
                        overlmtSelfpay: data.overlmt_selfpay,//超限价自费费用
                        preselfpayAmt: data.preselfpay_amt,//先行自付金额
                        inscpScpAmt: data.inscp_scp_amt,//符合政策范围金额
                        actPayDedc: data.act_pay_dedc,//实际支付起付线
                        hifpPay: data.hifp_pay,//基本医疗保险统筹基金支出
                        poolPropSelfpay: data.pool_prop_selfpay,//基本医疗保险统筹基金支付比例
                        cvlservPay: data.cvlserv_pay,//公务员医疗补助资金支出
                        hifesPay: data.hifes_pay,//企业补充医疗保险基金支出
                        hifmiPay: data.hifmi_pay,//居民大病保险资金支出
                        hifobPay: data.hifob_pay,//职工大额医疗费用补助基金支出
                        mafPay: data.maf_pay,//医疗救助基金支出
                        othPay: data.oth_pay,//其他支出
                        psnPartAmt: data.psn_pay,//个人负担总金额
                        psnCashPay: data.cash_payamt,//个人现金支出
                        // hospPartAmt: data.hosp_part_amt,//医院负担金额
                        balc: data.balc,//balc
                        acctMulaidPay: data.acct_mulaid_pay,//个人账户共济支付金额
                        medinsSetlId: data.medins_setl_id,//医药机构结算ID
                        clrWay: data.clr_way,//清算方式
                        setlTime: data.setl_time
                        // relation:,//与患者关系：1-本人，2-夫妻，3-子女，4- 父母
                    })
                }
                this.getFeeInfo(list, index += 1,clrOptins)
            })
        },
        //一键对账
        oneKeyCheck() {
            this.oneKey = true
            let list = _.cloneDeep(this.checkAccount.items)
            if (this.oneKeyIndex >= list.length) {
                return;
            }
            if (this.oneKeyIndex == (list.length - 1)) {
                this.oneKey = false
            }
            this.submitStmt(list[this.oneKeyIndex])
        },
    }

}
</script>

<style lang="less" scoped>
/deep/ .el-form-item--small.el-form-item {
    margin-bottom: 0px;

}

/deep/ .el-table thead {
    color: #5A6678;
}

.tableC /deep/ .el-table th.el-table__cell {
    background-color: #EBEAEE !important;
}

.customTable-wrap {
    border: 1px solid #EBEAEE;
    border-radius: 2px;
}

.backE8F {
    background-color: #E8F4FF;
}

.back0E1 {
    background-color: #FFF0E1;
}
</style>